import sortBy from "lodash/sortBy";
import { useContext } from "react";
import { useQuery } from "react-query";
import { PermissionsContext } from "../contexts";
import { fetchActionsIfPermitted } from "../screens/deployment/actions/api";
import { useOrg } from "./useOrg";

/*
 * Returns query result with actions from current selected org sorted by id
 */
export const useActions = (onError?: (error: Error) => void) => {
  const org = useOrg();
  const { permissions } = useContext(PermissionsContext);

  return useQuery(
    ["actions", { org }],
    () =>
      fetchActionsIfPermitted(org?.id!, permissions).then((response) =>
        sortBy(response, (action) => action.id)
      ),
    {
      enabled: Boolean(org),
      onError,
    }
  );
};
